export const BULLETS = [
  {
    title: 'Platform Rules',
    subText: 'You agree to abide by our platform rules',
  },
  {
    title: 'Introducer of Ideal4Finance',
    subText: "You'll become an IAR of Ideal4Finance",
  },
];
